import { render, staticRenderFns } from "./Migrate.vue?vue&type=template&id=6c5914cf&"
import script from "./Migrate.vue?vue&type=script&lang=ts&"
export * from "./Migrate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports